import { Subject } from '../types'

export const SUBJECTS: Subject[] = ['Math', 'ELA', 'Science']

export const SUBJECT_META: Record<Subject, { color: string; bg: string; icon: string; fullName: string }> = {
  Math: { color: '#1e40af', bg: '#eff6ff', icon: '∑', fullName: 'Mathematics (CCSS)' },
  ELA: { color: '#7c3aed', bg: '#f5f3ff', icon: 'A', fullName: 'English Language Arts (CCSS)' },
  Science: { color: '#065f46', bg: '#ecfdf5', icon: '⚛', fullName: 'Science (NGSS)' },
}
